/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
export function initMap( $el, hideControls = false ) {

  if (!$el.length) return;
  // Find marker elements within map.
  var $markers = $el.find('.marker');

  // Create gerenic map.
  var mapArgs = {
    zoom        : $el.data('zoom') || 16,
    mapTypeId   : google.maps.MapTypeId.ROADMAP,
    panControl: !hideControls,
    zoomControl: !hideControls,
    mapTypeControl: !hideControls,
    scaleControl: !hideControls,
    streetViewControl: !hideControls,
    overviewMapControl: !hideControls,
    rotateControl: !hideControls
  };
  var map = new google.maps.Map( $el[0], mapArgs );

  // Add markers.
  map.markers = [];
  $markers.each(function(){
    initMarker( $(this), map );
  });

  // Return map instance.
  return map;
}
let lastInfoWindow;
/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
export function initMarker( $marker, map ) {

  // Get position from marker.
  var lat = $marker.data('lat');
  var lng = $marker.data('lng');
  var latLng = {
    lat: parseFloat( lat ),
    lng: parseFloat( lng )
  };

  var icon = {
    path: "M192 0C86.4 0 0 86.4 0 192c0 76.8 25.6 99.2 172.8 310.4 9.6 12.8 28.8 12.8 38.4 0C358.4 291.2 384 268.8 384 192 384 86.4 297.6 0 192 0zm114.08 163.83L175.04 293.82c-4.31 4.28-11.28 4.25-15.55-.06l-75.72-76.33c-4.28-4.31-4.25-11.28.06-15.56l26.03-25.82c4.31-4.28 11.28-4.25 15.56.06l42.15 42.49 97.2-96.42c4.31-4.28 11.28-4.25 15.55.06l25.82 26.03c4.28 4.32 4.25 11.28-.06 15.56z",
    fillColor: '#003f49',
    fillOpacity: 1,
    anchor: new google.maps.Point(192, 512),
    strokeWeight: 0,
    scale: 0.1,
    //rotation: rotation
  }

  // Create marker instance.
  var marker = new google.maps.Marker({
    position : latLng,
    map: map,
    icon: icon,
    title: $marker.data('title')
  });

  // Append to reference for later use.
  map.markers.push( marker );

  // If marker contains HTML, add it to an infoWindow.
  if( $marker.html() ){

    // Create info window.
    var infowindow = new google.maps.InfoWindow({
      content: $marker.html()
    });

    // Show info window when marker is clicked.
    google.maps.event.addListener(marker, 'click', () => {

      if (lastInfoWindow) {
        lastInfoWindow.close();
      }
      lastInfoWindow = infowindow;
      infowindow.open( map, marker );
    });
  }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
export function centerMap( map ) {

  // Create map boundaries from all map markers.
  let bounds = new google.maps.LatLngBounds();
  map.markers.forEach(function( marker ){
    bounds.extend({
      lat: marker.position.lat(),
      lng: marker.position.lng(),
    });
  });

  // Case: Single marker.
  if( map.markers.length == 1 ){
    map.setCenter( bounds.getCenter() );
    // Case: Multiple markers.
  } else{
    setTimeout( function() {

      if ($(window).width() > 768) {
        map.fitBounds( bounds, 250 );
      } else {
        map.fitBounds( bounds );
      }
      }, 1 );
  }
}/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
export function panMap( map, x = 0, y = 0 ) {

  var latLng = new google.maps.Point(x, y);
  map.panTo(latLng);

}
